<template>
  <div :class="xNs">
    <slot />
  </div>
</template>
<script lang="ts" setup>
import { computed, provide } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { buttonGroupProps } from './button-group'

defineOptions({
  name: 'XzxButtonGroup',
})

const props = defineProps(buttonGroupProps)

const ns = useNamespace('button-group')

const xNs = computed(() => [
  ns.b(),
  ns.is(props.direction),
  props.reverse && ns.m('reverse'),
])

export interface ProvideProps {
  block: boolean
}

const provideProps = {
  block: props.block,
}

provide('XzxButtonGroup', provideProps)
</script>
